import { Injectable } from '@angular/core';
import { RequestService } from '@src/app/services/request.service';
import { BadgeApiInfo } from '@src/app/shared/types/badge.type';
import { PointTaskApiInfo } from '@src/app/shared/types/point-tasks.type';

export interface CheckWeekInfo {
    login_streak: number;
    login_today: boolean;
    login_start_date: string;
    earned_badges?: BadgeApiInfo[];
    login_records: PointTaskApiInfo[];
}

export interface RetroactiveCardInfo {
    data: { id: number; user_id: string; earned_at: string; used_at: string }[];
    earned_today: boolean;
    used_today: number;
    used_current_month: number;
}

@Injectable()
export class CheckInWeekService {
    constructor(private requestService: RequestService) {}

    getCheckInWeekInfo() {
        return this.requestService.sendRequest<CheckWeekInfo>({
            method: 'GET',
            url: '/v1/socialscan/user/check_in',
        });
    }

    checkIn() {
        return this.requestService.sendRequest<CheckWeekInfo>({
            method: 'POST',
            url: '/v1/socialscan/user/check_in',
            data: null,
        });
    }

    retroactiveCardInfo() {
        return this.requestService.sendRequest<RetroactiveCardInfo>({
            method: 'GET',
            url: '/v1/socialscan/user/retroactive_card',
        });
    }
}
